export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80 pt-14 md:pt-20 pb-8">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <span className="font-heading text-2xl text-background-50 mb-4 block">51影院</span>
            <p className="text-sm text-background-50/60 leading-relaxed">
              全网影视资源聚合平台，汇聚奇优影院、97影院、窝窝影院、第九影院等热门站点，提供最新电影、热播电视剧、热门综艺一站式高清在线观影服务。
            </p>
          </div>

          <div>
            <h4 className="font-medium text-background-50 text-sm mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#ranking" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a></li>
              <li><a href="#cards" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">影视专题</a></li>
              <li><a href="#index" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">分类索引</a></li>
              <li><a href="#updates" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">更新动态</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-background-50 text-sm mb-4">帮助支持</h4>
            <ul className="space-y-2.5">
              <li><a href="#faq" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
              <li><a href="#contact" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a></li>
              <li><a href="#about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a></li>
              <li><a href="#comments" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">用户评价</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-background-50 text-sm mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/60 leading-relaxed">
              期待更多优质影视内容平台加入合作，共同为影视爱好者提供更好的观影选择。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/60 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/60 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-background-50/60 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40 text-center sm:text-left">
            &copy; {new Date().getFullYear()} 51影院. 本站所有内容均来自公开网络资源，仅供学习交流使用。
          </p>
          <p className="text-xs text-background-50/40">
            奇优影院 · 97影院 · 窝窝影院 · 第九影院 · 全网影视
          </p>
        </div>
      </div>
    </footer>
  );
}